import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon AccountProfileDisabledIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const AccountProfileDisabledIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 23 28">
      <g clipPath="url(#clip0_730_17289)">
        <path
          d="M10.9207 13.1518C14.258 13.1518 16.9634 10.4464 16.9634 7.10908C16.9634 3.77177 14.258 1.06635 10.9207 1.06635C7.58336 1.06635 4.87793 3.77177 4.87793 7.10908C4.87793 10.4464 7.58336 13.1518 10.9207 13.1518Z"
          fill="#C9C9C9"
        />
        <path
          d="M8.53094 15.2453H14.2182C16.4808 15.2453 17.5 15.2453 18 16C15 17.5 12.5 21.5 14.0619 27.0146H11.3746H0V22.3069C0 20.434 0.898793 18.6379 2.49865 17.3136C4.09852 15.9893 6.26839 15.2453 8.53094 15.2453Z"
          fill="#C9C9C9"
        />
      </g>
      <defs>
        <clipPath id="clip0_730_17289">
          <rect width={22.7492} height={27.0146} fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
export default AccountProfileDisabledIcon
